var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{staticClass:"overflow-x-auto w-full font-mono whitespace-nowrap",attrs:{"rows":"30"},domProps:{"textContent":_vm._s(_vm.textileTable)},on:{"click":function($event){return $event.target.select()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }